import { Text } from "@mantine/core";

export default function HeaderTitle({ children, testId }: { children: string; testId?: string }) {
  return (
    <Text size="0.95rem" fw={600} truncate maw="30vw" c="var(--mantine-color-bright)" data-testid={testId}>
      {children}
    </Text>
  );
}
